export default __webpack_public_path__ + "static/media/decorator.89b5e1e3.svg";